import { render, staticRenderFns } from "./login-info.vue?vue&type=template&id=05f9a53d&scoped=true&"
import script from "./login-info.vue?vue&type=script&lang=js&"
export * from "./login-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f9a53d",
  null
  
)

export default component.exports